import { createSlice } from "@reduxjs/toolkit";

const videoSlice = createSlice({
  name: "video",
  initialState: {
    videos: [],
  },
  reducers: {
    addVideo: (state, action) => {
      state.videos.push(...state.videos, ...action.payload);
    },
    videoRemaining: (state, action) => {
      state.videos.length = 0;
      state.videos.push(...action.payload);
    },
  },
});

export const { addVideo, videoRemaining } = videoSlice.actions;
export default videoSlice.reducer;
